// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uxp_wd-ac__option{display:flex;padding:10px;align-items:center;cursor:pointer}.uxp_wd-ac__option:hover{background-color:var(--highlightBGColor)}.uxp_wd-ac__option .uxp_wd-ac__type{width:50px;font-size:1rem;align-items:center;background-color:var(--secondaryBGColor);padding:5px}.uxp_wd-ac__option .uxp_wd-ac__value{margin-inline-start:5px;font-size:1rem}", ""]);
// Exports
module.exports = exports;
